"use strict";
/**
 * File that contains the storage errors in en language.
 * Created on: Fri, 29 Jul 2022 01:18:51 GMT
 * Generated by "fto.js", file created by Jebbarbas.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const en = ['en', {
        "storage/unknown": {
            toDev: "An unknown error occurred.",
            toClient: "default"
        },
        "storage/object-not-found": {
            toDev: "No object exists at the desired reference.",
            toClient: "default"
        },
        "storage/bucket-not-found": {
            toDev: "No bucket is configured for Cloud Storage",
            toClient: "default"
        },
        "storage/project-not-found": {
            toDev: "No project is configured for Cloud Storage",
            toClient: "default"
        },
        "storage/quota-exceeded": {
            toDev: "Quota on your Cloud Storage bucket has been exceeded. If you're on the no-cost tier, upgrade to a paid plan. If you're on a paid plan, reach out to Firebase support.",
            toClient: "Limit of the free plan exceeded, please return tomorrow."
        },
        "storage/unauthenticated": {
            toDev: "User is unauthenticated, please authenticate and try again.",
            toClient: "You must log in to perform this action."
        },
        "storage/unauthorized": {
            toDev: "User is not authorized to perform the desired action, check your security rules to ensure they are correct.",
            toClient: "You don't have the permissions to perform this action."
        },
        "storage/retry-limit-exceeded": {
            toDev: "The maximum time limit on an operation (upload, download, delete, etc.) has been excceded. Try uploading again.",
            toClient: "Waiting time exceeded."
        },
        "storage/invalid-checksum": {
            toDev: "File on the client does not match the checksum of the file received by the server. Try uploading again.",
            toClient: "Error with the file, try to upload it again."
        },
        "storage/canceled": {
            toDev: "User canceled the operation.",
            toClient: "Operation canceled by the user."
        },
        "storage/invalid-event-name": {
            toDev: "Invalid event name provided. Must be one of ['running', 'progress', 'pause']",
            toClient: "default"
        },
        "storage/invalid-url": {
            toDev: "Invalid URL provided to refFromURL(). Must be of the form: gs://bucket/object or https://firebasestorage.googleapis.com/v0/b/bucket/o/object?token=<TOKEN>",
            toClient: "default"
        },
        "storage/invalid-argument": {
            toDev: "The argument passed to put() must be 'File', 'Blob', or 'UInt8' Array. The argument passed to putString() must be a raw, 'Base64', or 'Base64URL' string.",
            toClient: "default"
        },
        "storage/no-default-bucket": {
            toDev: "No bucket has been set in your config's storageBucket property.",
            toClient: "default"
        },
        "storage/cannot-slice-blob": {
            toDev: "Commonly occurs when the local file has changed (deleted, saved again, etc.). Try uploading again after verifying that the file hasn't changed.",
            toClient: "Error with the file, try to upload it again."
        },
        "storage/server-file-wrong-size": {
            toDev: "File on the client does not match the size of the file recieved by the server. Try uploading again.",
            toClient: "Error with the file, try to upload it again."
        },
    }];
exports.default = en;
